'use strict';

import request from 'superagent';
import api from './core';

export function create(client) {
    return api.forwardResult(api.prepare(request.post(api.url('/clients/'))).send(client), 'id');
}

export function update(client) {
    const id = encodeURIComponent(client.id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/clients/${id}/`))).send(client),
        'id'
    );
}

export function merge(client, client2) {
    const id = encodeURIComponent(client.id);
    const withId = encodeURIComponent(client2.id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/clients/${id}/merge/?with=${withId}`))).send(client),
        'id'
    );
}

/**
 * Compute the query params to filter clients (used by the list and the excel
 * export)
 *
 * @param q {string} Text search
 * @param filters {array} List of possible filters
 * @param selection {object} Currently enabled filters
 * @returns {{q: string}}
 */
export function makeParams(q = '', filters = [], selection = {}) {
    const params = {q};

    filters.forEach((filter) => {
        if (filter.type === 'enum') {
            if (((selection[filter.param] || []).length) ||
                           selection.hasOwnProperty(filter.param)) {
                params[filter.param] = selection[filter.param];
            }
        } else if (filter.type === 'range') {
            const range = selection[filter.param];

            if (range[0] !== '') {
                params[`${filter.param}__gt`] = range[0];
            }

            if (range[1] !== '') {
                params[`${filter.param}__lt`] = range[1];
            }
        }
    });

    return params;
}

/**
 * Fetches a list of clients, possibly with filters.
 *
 * @param q {string} Text search
 * @param filters {array} List of possible filters
 * @param selection {object} Currently enabled filters
 * @param page {number} Page to display
 * @returns {Promise}
 */
export function list(q = '', filters = [], selection = {}, page = 1) {
    const params = makeParams(q, filters, selection);

    params.page = page;

    return api.forwardResult(
        api.prepare(request.get(api.url('/clients/')).query(params)),
        'results'
    );
}

export function fetch(id) {
    return api.forwardResult(api.prepare(request.get(api.url(`/clients/${id}/`))), 'id');
}

export function downloadUrl(q = '', filters = [], selection = {}) {
    const params = makeParams(q, filters, selection);

    return api.forwardResult(
        api.prepare(request.get(api.url('/clients/excel/')).query(params)),
        'url'
    );
}

export function setStatus(id, status) {
    return api.forwardResult(
        api.prepare(request.patch(api.url(`/clients/${id}/`))).send({status}),
        'id'
    );
}

export function getFilters() {
    return api.forwardResult(
        api.prepare(request.get(api.url('/clients/make_filters/'))),
        'filters'
    );
}

/**
 * Converts an adjective slug into the actual displayable value
 *
 * @param adjective {string} adjective slug
 * @returns {string} the displayable value or an empty string if not found
 */
export function getAdjectiveDisplay(adjective) {
    return ({
        vision: 'Visionnaire',
        confiance: 'Confiant',
        epargne: 'Prévoyant',
        transmission: 'Altruiste',
        depense: 'Épanoui',
        affect: 'Rationnel',
        equilibre: 'Responsable'
    }[adjective]) || '';
}



// WEBPACK FOOTER //
// ./src/api/client.js